import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../../login-service';

@Component({
  selector: 'app-financial-dashboard',
  templateUrl: './financial-dashboard.component.html',
  styleUrls: ['./financial-dashboard.component.scss']
})
export class FinancialDashboardComponent implements OnInit {
  SelectedstartDate=new Date();
  SelectedendDate=new Date();
  subscriptionList:any;
  filteredsubscriptions: any;
  subscriptionData=[];
  display:boolean=false;
  totalSubcriptionamount: any;
  usersList: any;
  tempinvoiceList: any;
  paymentsList: any;
  tempProposalBids: any;
  collaboList: any;
  invoicesList: any=[];
  invoicetotal: number;
  serviceChargetotal: number;
  totalRevenue: any;
  userType:any;
  subscriptionDataList: any[];
  constructor(private loginService:LoginService) { }
  
  ngOnInit(): void {
    this.GetSubscriptions();
    this.GetUsers();
    this.GetInvoices();
    this.GetProposalbids();
    this.GetCollabos();
  }
  GetUsers()
{
  this.loginService.GetUsers(3).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.usersList=JSON.parse(JSON.stringify(data));
    });
}
  GetSubscriptions(){
    this.loginService.GetSubscriptions().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.subscriptionList=JSON.parse(JSON.stringify(data));
      console.log(this.subscriptionList)
    })
  }
  GetInvoices(){
    this.loginService.GetInvoices().subscribe(data=>
      {
        data = JSON.parse(data['_body']);
              this.tempinvoiceList=JSON.parse(JSON.stringify(data));
            
      })
     
    }
    GetProposalbids(){
      this.loginService.GetPraposalBids().subscribe(data=>
        {
            data = JSON.parse(data['_body']);
            this.tempProposalBids=JSON.parse(JSON.stringify(data));
        })
    }
    GetCollabos(){
      this.loginService.GetCollabos(1).subscribe(data=>
          {
            data = JSON.parse(data['_body']);
                  this.collaboList=JSON.parse(JSON.stringify(data));
          })
        }
        SelectedType(){
          console.log(this.userType)
          if(this.userType=='0'){
            this.subscriptionDataList=this.subscriptionData
          }
          else{
            this.subscriptionDataList=this.subscriptionData.filter(x=>x.usertypeid==this.userType)
          }
          console.log(this.subscriptionDataList)
        }
  CompareDate(){
    var count=0
    var count1=0
    var count2=0
    this.display=true;
    this.subscriptionData=[]
    this.invoicesList=[]
this.filteredsubscriptions=this.subscriptionList.filter(x=>x.start_date.split("T")[0]>=this.SelectedstartDate && x.start_date.split("T")[0]<=this.SelectedendDate)

if(this.filteredsubscriptions.length>0){
for(var i=0;i<this.filteredsubscriptions.length;i++){
  var users=this.usersList.filter(x=>x.id==this.filteredsubscriptions[i].collaborator_id || x.id==this.filteredsubscriptions[i].initiator_id)
  console.log(users)
  if(users.length>0){
    console.log(users[0].user_name,users[0].user_type_id)
    this.subscriptionData.push({
      username:users[0].user_name,
      userid:users[0].id,
      email:users[0].email,
      amount:this.filteredsubscriptions[i].amount,
      date:this.filteredsubscriptions[i].start_date.split("T")[0],
      billing:this.filteredsubscriptions[i].billing,
      usertypeid:users[0].user_type_id
    })
    count=count+this.filteredsubscriptions[i].amount;
  }
}
this.subscriptionDataList=this.subscriptionData
console.log(this.subscriptionData)
this.totalSubcriptionamount=count;
}
let filterinvoiceList=this.tempinvoiceList.filter(x=>x.ispaid=='p')
for(var i=0;i<filterinvoiceList.length;i++){
  var filterbids=this.tempProposalBids.filter(x=>x.rowid==filterinvoiceList[i].proposalbidrowid)
       var collabos=this.collaboList.filter(x=>x.id==filterbids[0].collaboid)
       this.invoicesList.push({
         collaboname:collabos[0].title,
         collaboid:collabos[0].id,
         amount:filterbids[0].amount,
         servicechargepercent:filterbids[0].servicecharge_percent,
         servicechargeamount:filterbids[0].servicecharge_amount,
         colusername:filterbids[0].user_name,
         bidid:filterbids[0].rowid,
         invoiceid:filterinvoiceList[0].id
       })
       count1=count1+parseInt(filterbids[0].amount);
       count2=count2+parseInt(filterbids[0].servicecharge_amount);
}
this.invoicetotal=count1;
this.serviceChargetotal=count2;
this.totalRevenue=parseInt(this.totalSubcriptionamount)+count1+count2;
}
}
